<template>
    <div id="contenedor-album-main">
        <template v-if="!$vuetify.breakpoint.mobile">
            <album-listado-desktop
            :reportesFisicos="reportesFisicos"
            :contrato="contrato"
            :modulo="modulo"
            >
            </album-listado-desktop>
        </template>
        <template v-else>
            <album-listado-mobile
            :reportesFisicos="reportesFisicos"
            :contrato="contrato"
            :modulo="modulo"
            >
            </album-listado-mobile>
        </template>
    </div>
</template>

<script>
import AlbumListadoDesktop from '@/components/administracion/album/listado/Desktop.vue';
import AlbumListadoMobile from '@/components/administracion/album/listado/Mobile.vue';

export default {
  name: 'AlbumMain',
  props: {
    reportesFisicos: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    modulo: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    AlbumListadoDesktop,
    AlbumListadoMobile,
  },

};
</script>
